import { Grid } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { ERROR, GET } from "../../utils/constants";
import { useParams } from "react-router-dom";
import { IAlert } from "../../interfaces/alert";
import { fetchData } from "../../utils/dataProvider";
import OrderAuditInfo from "../../components/orders/audit/OrderAuditInfo";
import AuditWrapper from "../../components/orders/audit/AuditWrapper";
import { IOrderAudit, IOrderRaw } from "../../interfaces/order";
import { AUDIT_TAB_VALUES } from "../../components/tabs/AuditsTabs";
import { UserContext } from "../../contexts/userContext";

const OrderAudit = () => {
  const { trackingNumber } = useParams();
  const [audit, setAudit] = useState({} as IOrderAudit);
  const [alert, setAlert] = useState({} as IAlert);
  const [loading, setLoading] = useState(true);
  const [order, setOrder] = useState({} as IOrderRaw);
  const { selectedMarketplace } = useContext(UserContext);

  const getAudit = async () => {
    try {
      const response = await fetchData({
        url: `/orders/audit/orders/${trackingNumber}`,
        method: GET,
      });
      setAudit(response);
    } catch (error: any) {
      setAlert({ typeOfAlert: ERROR, message: error, showAlert: true });
    }
  };

  const getOrder = async () => {
    try {
      const response = await fetchData({
        url: `/orders/${trackingNumber}${
          selectedMarketplace && `?marketplaceId=${selectedMarketplace}`
        }`,
        method: GET,
      });

      setOrder(response);
    } catch (err: unknown) {
      setAlert({
        typeOfAlert: ERROR,
        message: (err as Error)?.message || String(err),
        showAlert: true,
      });
    }
  };

  const getAuditAndOrderDetails = async () => {
    await getAudit();
    await getOrder();
    setLoading(false);
  };

  useEffect(() => {
    getAuditAndOrderDetails();
  }, []);

  return (
    <AuditWrapper
      loading={loading}
      alert={alert}
      tabName={AUDIT_TAB_VALUES.STATUS_CHANGES}
    >
      <Grid container item xs={12} lg={9}>
        <OrderAuditInfo audit={audit} order={order} />
      </Grid>
    </AuditWrapper>
  );
};

export default OrderAudit;
